import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideMail, lucideCheckCircle2 } from '@ng-icons/lucide';
import { UserService } from '../../../core/auth/services/user.service';
import {ZardButtonComponent} from '../../../shared/components/button';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-confirmation-screen',
  standalone: true,
  imports: [NgIcon, ZardButtonComponent, NgOptimizedImage],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [provideIcons({  lucideMail, lucideCheckCircle2 })],
  templateUrl: './confirmation-screen.component.html',
  styleUrl: './confirmation-screen.component.css',
})
export class ConfirmationScreenComponent {
  protected readonly userService = inject(UserService);
  protected readonly router = inject(Router);
}
